module.exports = __webpack_public_path__ + "static/media/maf-19.61c15f52.png";